export const ArrowLeftIcon = ({
  stroke = '#525252',
  width = '16',
  height = '16',
  viewBox = '0 0 16 16',
  ...rest
}: React.SVGProps<SVGSVGElement>) => (
  <svg width={width} height={height} viewBox={viewBox} fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path
      d="M13.3333 8H2.66667M2.66667 8L7.33333 12.6667M2.66667 8L7.33333 3.33333"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
